<template>
    <Head title="Gyms" />

    <BreezeAuthenticatedLayout>
      <main class="container">

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

              <div class="flex m-2 p-2">
                <Link href="/gyms" class="px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded">Back</Link>
              </div>

              <!-- This example requires Tailwind CSS v2.0+ -->
              <div class="flex flex-col">
 


                <div class="grid place-content-center mt-10">
                  <form @submit.prevent="storeGym" class="bg-white shadow-md m-2 p-2 rounded">
                    <div class="sm:col-span-6">
                      <label for="title" class="block text-sm font-medium text-gray-700"> Name </label>
                      <div class="mt-1">
                        <input type="text" id="title" wire:model.lazy="title" name="title" v-model="form.title" class="block w-full transition duration-150 ease-in-out appearance-none bg-white border border-gray-400 rounded-md py-2 px-3 text-base leading-normal transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                      </div>
                    </div>
                    <div class="sm:col-span-6">
                      <label for="title" class="block text-sm font-medium text-gray-700"> Image </label>
                      <div class="mt-1">
                        <input type="file" id="image" wire:model="newImage" name="image" 
                        @input="form.image = $event.target.files[0]" class="block w-full transition duration-150 ease-in-out appearance-none bg-white border border-gray-400 rounded-md py-2 px-3 text-base leading-normal transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                      </div>
                    </div>
                    <div class="m-2 p-2">
                      <button type="submit" class="px-4 py-2 bg-green-400 hover:bg-green-600 rounded-lg text-white">Create</button>
                    </div>
                  </form>
                </div>




              </div>

            </div>
        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Side,
    },

    setup() {
      const form = useForm({
        title: null,
        image: null,
      });
      return { form };
    },

    methods: {
      storeGym() {
        this.form.post('/gyms')
      }
    }
  }




  // const form = useForm({
  //   title: null,
  //   image: null,
  // })

  // function storeGym() {
  //   form.post('/gyms')
  // }

</script>
